import { FormsRegisterStaticField } from './forms-register-static-field';
import { StaticFieldIds } from './static-field-ids.enum';

export class FormsRegisterFormVersionField extends FormsRegisterStaticField {
  public readonly id = StaticFieldIds.FormVersion;
  public content: string;

  constructor({ form, template }: any) {
    super({ form, template });
    this.content = `V${form.formVersion}`;
  }
}
